<h2 matDialogTitle>{{data.title}}</h2>
<mat-dialog-content>
    <p>{{data.msg}}</p>


</mat-dialog-content>
<mat-dialog-actions align="end">
    <button style="display:inline-block;width:80px;margin-left: 10px;margin-top: 0px;" class="btn btn-apportis-primary btn-block"
        (click)="ok()">{{'Ok' | translateOrgSpecific}}</button>
    <button *ngIf="!data.isAlert" style="display:inline-block;width:80px;margin-left: 10px;margin-top: 0px;" class="btn btn-apportis-primary btn-block"
        (click)="cancel()">{{'Cancel' | translateOrgSpecific}}</button>

</mat-dialog-actions>